<div class="row">
  @for (product of productList; track product) {
  <div [class.col-xl-3]="col_xl_3" [class.col-xl-4]="xl_4" [class.col-sm-3]="col_sm_3" [class.col-xl-4]="col_xl_4"
    [class.col-sm-4]="col_sm_4" [class.col-xl-6]="col_xl_6" [class.col-sm-6]="col_sm_6" [class.col-xl-12]="col_xl_12"
    [class.col-xl-2]="col_xl_2">
    <div class="card">
      <div class="product-box">
        <div class="product-img">
          @if (validateNewProduct(product.creationDate)) {
          <div class="ribbon ribbon-danger">New</div>
          }
          @if (product.discount != null) {
          <div class="ribbon ribbon-success ribbon-right">{{product.discount | percentage}}</div>
          }
          @if (product.mainImage != null) {
          <img class="img-fluid w-100" [src]="product.mainImage" alt="">
          }@else {
          <img class="img-fluid w-100" src="assets/homepage/courses/course1.png" alt="">
          }
          <div class="product-hover">
            <ul>
              @if (isTagAllowed(product.tags)) {
              <a (click)="createOrUpdateCart(product._id)">
                <li>
                  <i class="icon-shopping-cart"></i>
                </li>
              </a>
              }
              <li [routerLink]="['/product',product._id]">
                <span>
                  <i class="icon-eye"></i></span>
              </li>
            </ul>
          </div>
        </div>
        <div class="product-details">
          <a>
            <h4>{{product.name}}</h4>
          </a>
          <p>{{formatDescription(product.description)}}</p>
          @if (product.comparedPrice != null || product.comparedPrice>0) {
          <div class="product-price">{{formatAmount(product.price)}}
            <del>{{formatAmount(product.comparedPrice)}}</del>
          </div>
          }@else{
          <div class="product-price">
            {{formatAmount(product.price)}}
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }
</div>